import { SimpleText, XStack } from '@my/ui'
import { IconButton } from '../common'
import { color } from '@my/util'
import assets from '../../assets/images'

// ChatHeader Component
export const ChatHeader: React.FC<{ text?: string; additionalStuff?: any }> = ({ text, additionalStuff }) => (
  <XStack
    backgroundColor={color.tzaGreen}
    borderTopRightRadius={10}
    borderTopLeftRadius={10}
    alignItems="center"
    padding="$2"
    paddingHorizontal="$5"
    {...(additionalStuff ? {justifyContent: "space-between"} : {})}
  >
    <XStack
      alignItems="center"
      gap={15}
    >
      <IconButton
        iconSource={assets.TZALogo}
        iconTintColor={color.tzaGreen}
        iconWidth={35}
        iconHeight={35}
        buttonSize={50}
        onPress={() => {}}
        backgroundColor={color.white}
      />
      {text && (
        <SimpleText fontSize={20} fontWeight="700" color="#fff">
          {text}
        </SimpleText>
      )}
    </XStack>
    {additionalStuff || null}
  </XStack>
)
